import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import { IconProps } from '../../icon/src/icon.js'
import type Divider from './divider.vue'

// 定义组件props
export const dividerProps = buildProps({
  // 文字颜色
  textColor: {
    type: String,
    default: 'var(--color-text)',
  },
  // 分割线颜色
  borderColor: {
    type: String,
    default: 'var(--color-split)',
  },
  // 前缀图标名称
  prefixIcon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: '',
      color: '',
      size: '',
    }),
  },
  // 后缀图标名称
  suffixIcon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: '',
      color: '',
      size: '',
    }),
  },
  content: {
    type: String,
    default: '',
  },
} as const)

// props
export type DividerProps = ExtractPropTypes<typeof dividerProps>

// instance
export type DividerInstance = InstanceType<typeof Divider>
